export const LEVEL_LABEL: Record<string, string> = {
  high: "Priorité forte",
  med: "Priorité intermédiaire",
  low: "À surveiller",
};

export const LEVEL_CLASS: Record<string, string> = {
  high: "bg-red-50 text-red-700",
  med: "bg-amber-50 text-amber-700",
  low: "bg-emerald-50 text-emerald-700",
};
